export enum RentalMutationFlowDirections {
  ISSUANCE = 1,
  RETURN = 2
}
